import React from 'react';
import PropTypes from 'prop-types';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import PlacePerksAccountNavHeader from '@tcp/core/src/components/features/account/common/organism/PlacePerksAccountNavHeader';
import { isCanada } from '@tcp/core/src/utils/utils';
import RewardPointsStatusBarView from '../../RewardsPoints/views/tile/RewardPointsStatusBar.view';
import styles from '../styles/AccountHeaderRedesign.style';
import withStyles from '../../../../../../common/hoc/withStyles';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../../utils/labels/labelUtilty';
import AccountCommonLabels, { GLOBAL_LABELS } from '../../../labels/AccountCommon.labels';

const AccountHeaderRedesign = ({
  className,
  name,
  pointsToNextRewards,
  currentPoints,
  totalRewards,
  isPlcc,
  bagPageLabels,
  isPlacePerkEnabled,
  labels,
  totalSpend,
  currentPerkLevel,
  spendLeftForNextPerk,
}) => {
  const globalLabels = getLabelFromCopyOrFromTranslation(GLOBAL_LABELS, AccountCommonLabels);

  return (
    <div className={className}>
      <BodyCopy className="user-info" component="div">
        <span className="header-greets">{`${renderLabel(
          globalLabels?.header?.lbl_header_helloText,
          'lbl_header_helloText'
        )},`}</span>{' '}
        <span className="header-user-name">{name || ''}</span>
      </BodyCopy>
      {isPlacePerkEnabled && <div className="header-divider" />}
      {!isCanada() && (
        <BodyCopy component="div" className="reward-points-status-bar-container">
          <RewardPointsStatusBarView
            pointsToNextReward={pointsToNextRewards}
            currentPoints={currentPoints}
            totalRewards={totalRewards}
            plccUser={isPlcc}
            globalLabels={globalLabels}
            bagPageLabels={bagPageLabels}
            useRouterNavigation
          />
        </BodyCopy>
      )}
      {isPlacePerkEnabled && (
        <PlacePerksAccountNavHeader
          totalSpend={totalSpend}
          currentPerkLevel={currentPerkLevel}
          spendLeftForNextPerk={spendLeftForNextPerk}
          labels={labels}
        />
      )}
    </div>
  );
};
AccountHeaderRedesign.propTypes = {
  name: PropTypes.string,
  pointsToNextRewards: PropTypes.number,
  currentPoints: PropTypes.number,
  totalRewards: PropTypes.number,
  isPlcc: PropTypes.bool,
  isPlacePerkEnabled: PropTypes.bool,
  totalSpend: PropTypes.number,
  currentPerkLevel: PropTypes.string,
  spendLeftForNextPerk: PropTypes.number,
};
AccountHeaderRedesign.defaultProps = {
  name: '',
  pointsToNextRewards: 0,
  currentPoints: 0,
  totalRewards: 0,
  isPlcc: false,
  isPlacePerkEnabled: false,
  totalSpend: 0,
  currentPerkLevel: 'DEFAULT',
  spendLeftForNextPerk: 0,
};
export default withStyles(AccountHeaderRedesign, styles);
export { AccountHeaderRedesign as AccountHeaderRedesignVanilla };
